export enum EUserRoles {
  SUPER_ADMIN = 3,
  ACCOUNTANT = 2,
  BOSS = 1,
}

export enum EUserSmallRoles {
  MANAGER = 2,
  CLOSER = 1,
}
